import { render, staticRenderFns } from "./relation-edit-button.vue?vue&type=template&id=439cd0fa&scoped=true"
import script from "./relation-edit-button.vue?vue&type=script&lang=js"
export * from "./relation-edit-button.vue?vue&type=script&lang=js"
import style0 from "./relation-edit-button.vue?vue&type=style&index=0&id=439cd0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439cd0fa",
  null
  
)

export default component.exports